module.exports = __webpack_public_path__ + "static/media/w5.dff42c6d.png";